import { Box, useTheme } from "@mui/material";
import { Webhook } from "@mui/icons-material";
import { Idea } from "../../../w2d2d-api-client";
import AvatarWidget from "../users/AvatarWidget";

interface IdeaTypeBadgeProps {
    readonly idea: Idea | null;
    readonly remotePod?: string | null;
}

export default function IdeaTypeBadge({ idea, remotePod }: IdeaTypeBadgeProps) {
    const theme = useTheme();

    const BadgeContainer = ({ children, color, bgcolor }: { children: React.ReactNode, color: string, bgcolor: string }) => (
        <Box
            component="span"
            sx={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 1,
                bgcolor: bgcolor,
                color: color,
                px: 1.5,
                height: 32,
                borderRadius: 4, // Pill shape
                fontSize: '0.875rem',
                fontWeight: 600,
                lineHeight: 1.5,
            }}
        >
            {children}
        </Box>
    );

    let authorId = idea?.authorId;
    if (authorId) {
        // Private idea with author
        return (
            <BadgeContainer
                color={theme.palette.secondary.dark}
                bgcolor={theme.palette.secondary.light + '40'}
            >
                <AvatarWidget id={authorId} size={20} />
                <span>Privat</span>
            </BadgeContainer>
        )
    }

    // Public idea (no author)
    return (
        <BadgeContainer
            color={theme.palette.info.dark}
            bgcolor={theme.palette.info.light + '40'}
        >
            <Webhook sx={{ fontSize: 20 }} />
            <span>{remotePod}</span>
        </BadgeContainer>
    );
}
